import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  EditSavedViewAlertsMutation,
  EditSavedViewAlertsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { createAlertsUpdatedEvent } from "lib/savedViewTracking";
import { EventDataTypes, EventNames, useTracking } from "lib/tracking";
import { useGraphQlMutation } from "../../useGraphQlClient";

const editSavedViewAlerts = graphql(`
  mutation EditSavedViewAlerts($request: EditSavedViewAlertsRequest!) {
    editSavedViewAlerts(EditSavedViewAlertsRequest: $request)
  }
`);

export function useEditSavedViewAlerts(
  options?: UseMutationOptions<
    EditSavedViewAlertsMutation,
    unknown,
    EditSavedViewAlertsMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { logEvent } = useTracking();

  const { data, ...rest } = useGraphQlMutation(editSavedViewAlerts, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptionContents"] });
      void queryClient.invalidateQueries({ queryKey: ["leadSubscriptions"] });
      void queryClient.invalidateQueries({ queryKey: ["savedViews"] });

      options?.onSuccess && options?.onSuccess(data, variables, context);

      logEvent(
        EventNames.alertModified,
        createAlertsUpdatedEvent(
          variables.request.name || "",
          variables.request.alertFrequency ?? "NEVER",
          EventDataTypes.documents,
          variables.request.id,
        ),
      );
    },
  });

  return { data: data?.editSavedViewAlerts, ...rest };
}
